<div class="modal-header">
  <h4 class="modal-title roboTitle">Changelog</h4>
  <button type="button" class="btn-close" aria-label="Chiudi" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div *ngIf="loading" class="text-center py-4">Caricamento...</div>
  <div *ngIf="errore" class="alert alert-warning mb-0">Impossibile caricare il changelog.</div>
  <pre *ngIf="!loading && !errore" class="change-log-content">{{ changeLog }}</pre>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Chiudi</button>
</div>
